<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'

interface Props {
  rows: DetailsCarItemDetails['engineTransmissionTurbo']
}

defineProps<Props>()
</script>

<template>
  <table class="w-full border-collapse">
    <tr
      v-for="(row, index) in rows"
      :key="row[0]"
      :style="`${
        index < rows.length - 1 ? 'border-bottom: 1px solid #c1c1c1' : ''
      }`"
    >
      <td
        v-for="cell in row"
        :key="cell"
        class="px-1 py-4"
        :class="{
          'font-semibold': row.length === 1,
        }"
        :colspan="row.length === 1 ? 2 : undefined"
      >
        {{ cell }}
      </td>
    </tr>
  </table>
</template>
